<template>
  <div class="page-container">
    <div class="title-container">
      <Title :title="title" />
      <div></div>
    </div>
    <div class="container">
      <ProductFilters @on-filtered="onFilterChange" />
      <div class="flex">
        <div class="flex-none">
          <div class="secondary-side__menu">
            <Menu :items="menuLinks" :disabled="isFiltered" />
          </div>
        </div>
        <div class="flex-grow ml-4 sub-content__area">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Bus } from "../../eventBus";
import authentication from "../../authentication";
export default {
  components: {
    Title: () => import(/* webpackPrefetch: true */ "../common/Title"),
    ProductFilters: () =>
      import(/* webpackPrefetch: true */ "./ProductFilters"),
    Menu: () => import(/* webpackPrefetch: true */ "../common/Menu"),
  },
  data: () => ({
    title: "View Product",
    isLoader: true,
    isFiltered: true,
    menuLinks: [
      {
        name: "General Information",
        path: "/product-details/generalinfo",
      },
      {
        name: "Assigned Formulation/CUC",
        path: "/product-details/assignedformulation",
      },
    ],
  }),
  created() {
    this.fetchCountries();
  },
  methods: {
    ...mapActions({
      updateIsfiltered: "fetchIsFiltered",
      updateCountries: "fetchCountries",
      updateIsMenuOpen: "fetchIsMenuOpen",
    }),
    onFilterChange(val) {
      this.isFiltered = !val;
      this.updateIsfiltered(val);
      this.updateIsMenuOpen(false);
      if (this.$route.name === "productdetails") {
        this.$router.push({ name: "generalinfo" }).catch(() => {});
      } else {
        this.$router.push({ name: this.$route.name }).catch(() => {});
      }
    },
    async fetchCountries() {
      try {
        const { data } = await this.$http
          .get(
            `${
              process.env.VUE_APP_API_URL
            }/FormulationMapping/GetCountriesByUser/${authentication.getUserEmail()}`
          )
          .catch((error) => {
            Bus.$emit("notification", {
              text: error,
              type: "error",
            });
          });
        this.updateCountries(data);
      } catch (error) {
        this.isLoader = false;
        console.log("error: ", error);
        Bus.$emit("notification", {
          text: error,
          type: "error",
        });
      }
    },
  },
};
</script>
